var isFinished;

const state = {
  validateEmail(email) {
    let re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return re.test(email);
  },
  fireOnceUponEventEnd(func, time = 250) {
    window.clearTimeout(isFinished);
    isFinished = setTimeout(() => {
      func();
    }, time);
  },
  convertTimestamp(secs) {
    var sec_num = parseInt(secs, 10)
    var hours   = Math.floor(sec_num / 3600) % 24
    var minutes = Math.floor(sec_num / 60) % 60
    var seconds = sec_num % 60
    return [hours,minutes,seconds]
      .map(v => v < 10 ? "0" + v : v)
      .filter((v,i) => v !== "00" || i > 0)
      .join(":");
  },
  timestampToSeconds(timestamp) {
    const parts = timestamp.split(":");
    return parts.map(t => t * 60).reduce((acc, val) => ( acc + val));
  },
};

export default state;